// Static asset paths (served from /public/assets). Mirrors the original
// window.__resources map from the source design.
export const R = {
  pTaboola: "/assets/img/pTaboola.png",
  pGoogle: "/assets/img/pGoogle.png",
  pTikTok: "/assets/img/pTikTok.png",
  pMicrosoft: "/assets/img/pMicrosoft.png",
  pOutbrain: "/assets/img/pOutbrain.png",
  pMeta: "/assets/img/pMeta.png",
  udLogo: "/assets/img/udLogo.png",
  leeRyan: "/assets/img/leeRyan.jpg",
  lee: "/assets/img/lee.jpg",
  ryan: "/assets/img/ryan.jpg",
} as const;
